import { MasterDataTranslator } from 'src/translators'
import { useGetMasterDataQuery } from 'src/types/generated'

export const useMasterData = () => {
  const { loading, data, error } = useGetMasterDataQuery()

  return {
    loading,
    masterData: data ? MasterDataTranslator.toEntity(data) : null,
    error,
  }
}
